import {useState, useRef, useEffect} from 'react';

import {keyframes, Keyframes} from 'styled-components';

export const DELIVERY_TRACKER_ANIMATION_SECONDS = 2;

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

export const fadeOut = keyframes`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;

export const useDeliveryTrackerAnimation = () => {
  const [keyFrame, setKeyFrame] = useState<Keyframes | null>(null);
  const timersRef = useRef<ReturnType<typeof setTimeout>[]>([]);

  useEffect(() => {
    const timers = timersRef.current;
    return () => {
      timers.forEach(clearTimeout);
    };
  }, []);

  const activateAnimation = (changeState: () => void) => {
    const outer = setTimeout(() => {
      setKeyFrame(fadeIn);
      changeState();
      const inner = setTimeout(() => setKeyFrame(null), 1000 * DELIVERY_TRACKER_ANIMATION_SECONDS);
      timersRef.current.push(inner);
    }, 1000 * DELIVERY_TRACKER_ANIMATION_SECONDS);
    timersRef.current.push(outer);
    setKeyFrame(fadeOut);
  };

  return {keyFrame, activateAnimation};
};
